<div class="row">
    <div class="col-12 col-md-3">
        <form #f="ngForm" (ngSubmit)="f.valid && data.password == data.confirm_password && submit()" novalidate>
            <h3 class="fs-4 fw-bold">Change Password</h3>
            <div class="mb-3">
                <label for="password" class="form-label">Password</label>
                <input type="password" class="form-control" id="password" name="password" #password="ngModel" [(ngModel)]="data.password" required maxlength="20" minlength="6">
                <div *ngIf="f.submitted && password.invalid" class="invalid-feedback">
                    <div *ngIf="password.errors.required">Password is required</div>
                    <div *ngIf="password.errors.minlength">Password must be at least 6 characters</div>
                </div>
            </div>
            <div class="mb-3">
                <label for="confirm_password" class="form-label">Confirm Password</label>
                <input type="password" class="form-control" id="confirm_password" name="confirm_password" #confirm_password="ngModel" [(ngModel)]="data.confirm_password" required maxlength="20" minlength="6">
                <div *ngIf="f.submitted && confirm_password.invalid" class="invalid-feedback">
                    <div *ngIf="confirm_password.errors.required">Confirm Password is required</div>
                    <div *ngIf="confirm_password.errors.minlength">Confirm Password must be at least 6 characters</div>
                </div>
                <div *ngIf="f.submitted && data.password != data.confirm_password" class="invalid-feedback">
                    <div>Password Not Match</div>
                </div>
            </div>
            <button type="submit" class="btn btn-primary">Update</button>
        </form>
    </div>
</div>